import { useState } from 'react';
import { SubscriptionTier } from '../../../type';
import { getSubscriptionFormDataCookie } from '../../../lib/cookies';

interface UseSelectedTierSliceArgs {
    sellerName: string;
}

export const useSelectedTierSlice = ({ sellerName }: UseSelectedTierSliceArgs) => {
    const formData = getSubscriptionFormDataCookie(sellerName);
    const defaultTier = formData?.subscriptionTier ?? SubscriptionTier.Standard;

    const [selectedTier, setSelectedTier] = useState<SubscriptionTier>(defaultTier);

    const handleChangeTier = (tierName: SubscriptionTier) => {
        setSelectedTier(tierName);
    };

    return { selectedTier, onChangeTier: handleChangeTier };
};
